module.exports = __webpack_public_path__ + "static/media/instagram.3e355b53.svg";